
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/payments",
      function () {
        return require("private-next-pages/account/payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/payments"])
      });
    }
  